import {View} from 'react-native'

export const defaultSystemFonts: string[] = []

interface Props {
  contentWidth?: number
  source: {html: string}
  systemFonts?: string[]
  tagsStyles?: Record<string, any>
}

function styleToCss(style: Record<string, any> = {}): React.CSSProperties {
  return style as React.CSSProperties
}

export default function RenderHtml({source, tagsStyles = {}}: Props) {
  return (
    <View>
      <div
        style={styleToCss(tagsStyles.div)}
        dangerouslySetInnerHTML={{__html: source.html}}
      />
    </View>
  )
}
